import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ToastModel } from "../../models/ToastModel";
import { AlertColor } from "@mui/material/Alert";

interface IToastModel extends ToastModel {
  displayToast: (msg: string, variant?: AlertColor) => void;
}

const initialToastState: IToastModel = {
  variant: "info",
  msg: "",
  displayToast: () => {},
};

const ToastSlice = createSlice({
  name: "toast",
  initialState: initialToastState,
  reducers: {
    addDisplayToast(
      state,
      action: PayloadAction<(msg: string, variant?: AlertColor) => void>
    ) {
      state.displayToast = action.payload;
    },
    showToast(state, action: PayloadAction<ToastModel>) {
      state.variant = action.payload.variant;
      state.msg = action.payload.msg;
    },
  },
});
export default ToastSlice;
